import React from 'react'
import { Row, Col, Typography } from 'antd'
import { CustomModal } from 'src/components'
import { useTranslation } from 'next-i18next'
import { useAppSelector } from 'src/app/hooks'
import { currencyListSelector } from 'src/features'
import { IntegrationProjects } from 'src/core/models'
import { getDateFormatted, getFormatedPrice } from 'src/core/helpers'
const { Title } = Typography

interface PropsType {
  isModalVisible: boolean,
  handleCancel: () => void,
  project: IntegrationProjects
}

const IntegrationProjectDetailsModal = (props: PropsType) => {
  const { isModalVisible, handleCancel, project } = props
  const { t } = useTranslation()
  const currencyList = useAppSelector(currencyListSelector)
  const currencyCode = currencyList.find(c => c?.symbol === project.currency_symbol)?.code
  const amount = `${getFormatedPrice(project.transactions_data.amount, currencyCode)} (${project.transactions_data.co2_amount} t)`
  const sotck = `${project.available_volume_credits} t (${project.average_stock_available} %)`

  const projectLabels = [
    { label1: t('admin.Brokerage.ProjectId'), label2: project.id },
    { label1: t('admin.Brokerage.ProjectName'), label2: project.name },
    { label1: t('developers.TotalTransaction'), label2: amount },
    { label1: t('developers.StockAvailable'), label2: sotck },
    { label1: t('developers.LastEdit'), label2: getDateFormatted(project.modified) }
  ]

  return (
    <CustomModal
      title={t('Transactions.CheckProjectDetails')}
      footer={null}
      open={isModalVisible}
      onCancel={handleCancel}
    >
      {projectLabels.map((item, idx) => (
        <React.Fragment key={idx}>
          <Row>
            <Col xs={24} lg={8}>
              <Title level={5} type='secondary'>{item.label1}</Title>
            </Col>
            <Col xs={24} lg={16}>
              <Title level={5}>{item.label2}</Title>
            </Col>
          </Row>
        </React.Fragment>
      ))}
    </CustomModal>
  )
}
export default IntegrationProjectDetailsModal
